/**
 * 客户端配置
 * 不能将服务端配置暴露在客户端，所以不能直接用`config/*`
 */

const PRODUCTION = process.env.EGG_SERVER_ENV === 'prod';

// 编译决定运行环境：prod | pre | test | dev | local
const ENV = process.env.EGG_SERVER_ENV;
const TANTU_ORIGIN = PRODUCTION ? 'https://m.tantu.com' : 'https://m-dev.tantu.com';

const config = {
  env: ENV,
  version: process.env.VERSION,
  sentry: {
    dsn: 'https://69b68155a3474fe5ac0da7d956d0150d@logger2.zuzuche.com/42'
  }
};


export {
  ENV,
  TANTU_ORIGIN
};

export default config;
